import { render, staticRenderFns } from "./nbbankfiles.vue?vue&type=template&id=97625718&"
import script from "./nbbankfiles.vue?vue&type=script&lang=js&"
export * from "./nbbankfiles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports